import HeroSectionComponent from './HeroSectionComponent';

const PressKitHeroSection = ({ slice }) => (
  <HeroSectionComponent slice={slice} />
);

export default PressKitHeroSection;
